<ng-container *ngIf="toaster">
  <div class="toaster-unit  js-toaster-{{ toaster.id }}">
    <!-- <div *ngIf="toaster.type ===  TOASTER_TYPE.SUCCESS" class="icon toaster-{{ toaster.type }}"> <span class="material-symbols-outlined d-flex"> done </span> </div> -->
    <!-- <div *ngIf="toaster.type ===  TOASTER_TYPE.DANGER"  class="icon toaster-{{ toaster.type }}"> <span class="material-symbols-outlined d-flex"> error </span> </div> -->
    <!-- <div *ngIf="toaster.type ===  TOASTER_TYPE.WARNING" class="icon toaster-{{ toaster.type }}"> <span class="material-symbols-outlined d-flex"> warning </span> </div> -->
    <!-- <div *ngIf="toaster.type ===  TOASTER_TYPE.INFO"    class="icon toaster-{{ toaster.type }}"> <span class="material-symbols-outlined d-flex"> info_i </span> </div> -->

    <div class="tap toaster-{{ toaster.type }}"></div>

    <div class="box-content">
      <div class="title" [innerHTML]="toaster.title"></div>

      <div class="content" [innerHTML]="toaster.content"></div>
    </div>

    <button type="button" class="box-close" (click)="closeIt(toaster.id!)">
      <span class="material-symbols-outlined icon-close"> close </span>
    </button>
  </div>
</ng-container>
